<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.snils }"
      )
        .form-elem__title СНИЛС
        .form-elem__body
          input.input.input_full(
            v-model="localSnils"
            v-on:keyup="keymonitor"
            v-mask="'###-###-### ##'"
          )

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.inn }"
      )
        .form-elem__title ИНН
        .form-elem__body
          input.input.input_full(
            v-model="localInn"
            v-on:keyup="keymonitor"
            maxlength="12"
          )

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport }"
      )
        .form-elem__title Серия и номер паспорта
        .form-elem__body
          input.input.input_full(
            v-model="localPassport"
            v-on:keyup="keymonitor"
            v-mask="'## ## ######'"
          )

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport_issue_by }"
      )
        .form-elem__title Кем выдан паспорт
        .form-elem__body
          input.input.input_full(
            v-model="localPassportIssueBy"
            v-on:keyup="keymonitor"
            maxlength="255"
          )

    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport_issue_date }"
      )
        .form-elem__title Дата выдачи паспорта
        .form-elem__body
          //- input.input.input_full(
          //-   placeholder="дд.мм.гггг"
          //-   v-model="localPassportIssueDate"
          //-   @blur="onBlurDate($event)"
          //-   v-on:keyup="onChangeDate($event)"
          //- )
          date-picker(
            placeholder="дд.мм.гггг"
            v-model="localPassportIssueDate"
            format="DD.MM.YYYY"
            lang="ru"
            input-class="input input_full"
            @change="onChangeDate($event)"
            :clearable="false"
            :editable="true"
            :not-after="new Date()"
          )

    .form__elem.form__elem_full
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport_attachments }"
      )
        .form-elem__title Копия паспорта
        .form-elem__body
          attach-file(
            :attachments="passportAttachments"
            attachment-type="passport"
            fieldname="passport_attachments"
            @onChangeAttachments="changeAttachments"
          )
          .form-elem__description Страницы фото, кем выдан, прописка

    .form__elem.form__elem_full
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.anotherDocuments }"
      )
        .form-elem__title Другие документы
        .form-elem__body
          attach-file(
            :attachments="anotherDocuments"
            attachment-type="file"
            fieldname="another_documents"
            @onChangeAttachments="changeAttachments"
          )
          .form-elem__description ИНН, страховой полис
</template>
<script>
import AttachFile from "@/components/attach-file/AttachFile";
import DatePicker from "vue2-datepicker";

export default {
  name: "FormDocs",
  components: {
    AttachFile,
    DatePicker
  },
  props: {
    snils: {
      type: [String, Object],
      default: ""
    },
    inn: {
      type: [String, Object],
      default: ""
    },
    passport: {
      type: [String, Object],
      default: ""
    },
    passportIssueBy: {
      type: [String, Object],
      default: ""
    },
    passportIssueDate: {
      type: [String, Object],
      default: ""
    },
    passportAttachments: {
      type: Array,
      default: () => []
    },
    anotherDocuments: {
      type: Array,
      default: () => []
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    localSnils: {
      get() {
        return this.snils;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "snils"]);
      }
    },
    localInn: {
      get() {
        return this.inn;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "inn"]);
      }
    },
    localPassport: {
      get() {
        return this.passport;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "passport"]);
      }
    },
    localPassportIssueBy: {
      get() {
        return this.passportIssueBy;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "passport_issue_by"]);
      }
    },
    localPassportIssueDate: {
      get() {
        if (!this.passportIssueDate) {
          return "";
        }
        return this.passportIssueDate;
      },
      set() {}
    }
  },
  methods: {
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.$emit("onChangeValue", [_date, "passport_issue_date"]);
    },
    changeAttachments(data) {
      this.$emit("onChangeValue", [data.value, data.fieldname]);
      this.keymonitor();
    }
  }
};
</script>
